<template>
  <select v-model="newValue" class="form-control" v-on:change="emitChange">
    <option v-for="option in priorities" v-bind:value="option.value" v-bind:key="option.value">
      {{ option.label }}
    </option>
  </select>
</template>
<script>
import {priorities} from '@/mixins/priorities.js';

export default {
  props: ['value'],
  data: function() {return {
    priorities,
    newValue: null,
  }},
  watch: {
    value(newVal) {
      this.newValue = newVal
    }
  },
  methods: {
    emitChange() {
      this.$emit('input', this.newValue);
    }
  },
  mounted() {
    this.newValue = this.value
  }
}
</script>